export enum AppPath {
  HOME = '/',

  PRODUCT = '/:productUrlName',
  PROPOSAL = '/:productUrlName/proposal/:proposalCode',
  RENEWAL = '/:productUrlName/renewal/:proposalCode',
  POLICY = '/:productUrlName/policy/:policyId',

  PREFILL = '/prefill',
  RETRIEVE = '/retrieve',
  CALLBACK = '/callback',
  SIGN_IN = '/sign-in',
  ACCOUNT = '/account',

  WILDCARD = '/*',
}
